import { Component, ElementRef, OnInit, Type, ViewChild } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { FooterRendererType, HeadFootEnum, LinkType, OrientationEnum, ProductRowLayoutEnum, RendererType, SectionData } from '@urbannex/storethemes';
import { ProductListInputDialogComponent } from './product-list-input-dialog/product-list-input-dialog.component';

@Component({
  selector: 'kve-home-product-list',
  templateUrl: './home-product-list.component.html',
  styleUrls: ['./home-product-list.component.scss']
})
export class HomeProductListComponent implements OnInit {
  title = "Add Product List Rows";
  collapsed:boolean = true;
  row3Data:SectionData = {
    title:{
      elId:'1',
      text:"Four Row Products",
      name:"Title",
      classes:["h6","justify-center"]
    },
    heading:"The section heading",
    numberOfElements:4,
    rendererType:RendererType.ROW,
    rowOptions:{
      layoutClass:ProductRowLayoutEnum.FOUR_COL_PORTRIAT,
      numberOfElements:4,
      rowCells:[
        {
          cellId:"001",
          imageOrientation:OrientationEnum.LANDSCAPE,
          imgSrc:"https://placehold.co/200x200?text",
          altImgSrc:"https://placehold.co/305x171/orange/white",
          width:"305",
          height:"171",
          headerFooterEnum:HeadFootEnum.FOOTER_ONLY,
          footerRendererType:FooterRendererType.PRODUCT_SUMMARY,
          contentElements:[
            {
              elId:"01",
              name:"Price",
              text:"R199,99",
              classes:[
                "fnt-size-standard-large","kve-autoWidth","justify-center"
              ]
            },
            {
              eldId:"02",
              name:"Discount",
              text:"50%",
            },
            {
              eldId:"03",
              name:"Product Name",
              text:"Men's Jacket",
              isLink:true,
              linkType:LinkType.TEXT,
              action:"goToProduct"
            },
            {
              eldId:"04",
              name:"Category",
              text:"Men's Clothing",
              isLink:true,
              linkType:LinkType.TEXT,
              action:"goToCategory"
            },
            {
              eldId:"05",
              name:"Add To Cart",
              isLink:true,
              text:"Add To Cart",
              action:"addToCart",
              linkType:LinkType.ICON,
              iconClass:"fa fa-shopping-bag"
            },
            {
              eldId:"06",
              name:"Add To Wish List",
              isLink:true,
              text:"Add To Wish List",
              action:"addToWishList",
              linkType:LinkType.ICON,
              iconClass:"far fa-heart"
            },
          ]
        },
        {
          cellId:"002",
          imageOrientation:OrientationEnum.LANDSCAPE,
          imgSrc:"https://placehold.co/200x200?text",
          altImgSrc:"https://placehold.co/305x171/orange/white",
          width:"305",
          height:"171",
          headerFooterEnum:HeadFootEnum.FOOTER_ONLY,
          footerRendererType:FooterRendererType.PRODUCT_SUMMARY,
          contentElements:[
            {
              elId:"01",
              name:"Price",
              text:"R199,99",
              classes:[
                "fnt-size-standard-large","kve-autoWidth","justify-center"
              ]
            },
            {
              eldId:"02",
              name:"Discount",
              text:"50%",
            },
            {
              eldId:"03",
              name:"Product Name",
              text:"Men's Jacket",
              isLink:true,
              linkType:LinkType.TEXT,
              action:"goToProduct"
            },
            {
              eldId:"04",
              name:"Category",
              text:"Men's Clothing",
              isLink:true,
              linkType:LinkType.TEXT,
              action:"goToCategory"
            },
            {
              eldId:"05",
              name:"Add To Cart",
              isLink:true,
              text:"Add To Cart",
              action:"addToCart",
              linkType:LinkType.ICON,
              iconClass:"fa fa-shopping-bag"
            },
            {
              eldId:"06",
              name:"Add To Wish List",
              isLink:true,
              text:"Add To Wish List",
              action:"addToWishList",
              linkType:LinkType.ICON,
              iconClass:"far fa-heart"
            },
          ]
        },
        {
          cellId:"003",
          imageOrientation:OrientationEnum.LANDSCAPE,
          imgSrc:"https://placehold.co/200x200?text",
          altImgSrc:"https://placehold.co/305x171/orange/white",
          width:"305",
          height:"171",
          headerFooterEnum:HeadFootEnum.FOOTER_ONLY,
          footerRendererType:FooterRendererType.PRODUCT_SUMMARY,
          contentElements:[
            {
              elId:"01",
              name:"Price",
              text:"R199,99",
              classes:[
                "fnt-size-standard-large","kve-autoWidth","justify-center"
              ]
            },
            {
              eldId:"02",
              name:"Discount",
              text:"50%",
            },
            {
              eldId:"03",
              name:"Product Name",
              text:"Men's Jacket",
              isLink:true,
              linkType:LinkType.TEXT,
              action:"goToProduct"
            },
            {
              eldId:"04",
              name:"Category",
              text:"Men's Clothing",
              isLink:true,
              linkType:LinkType.TEXT,
              action:"goToCategory"
            },
            {
              eldId:"05",
              name:"Add To Cart",
              isLink:true,
              text:"Add To Cart",
              action:"addToCart",
              linkType:LinkType.ICON,
              iconClass:"fa fa-shopping-bag"
            },
            {
              eldId:"06",
              name:"Add To Wish List",
              isLink:true,
              text:"Add To Wish List",
              action:"addToWishList",
              linkType:LinkType.ICON,
              iconClass:"far fa-heart"
            },
          ]
        },
        {
          cellId:"004",
          imageOrientation:OrientationEnum.LANDSCAPE,
          imgSrc:"https://placehold.co/200x200?text",
          altImgSrc:"https://placehold.co/305x171/orange/white",
          width:"305",
          height:"171",
          headerFooterEnum:HeadFootEnum.FOOTER_ONLY,
          footerRendererType:FooterRendererType.PRODUCT_SUMMARY,
          contentElements:[
            {
              elId:"01",
              name:"Price",
              text:"R199,99",
              classes:[
                "fnt-size-standard-large","kve-autoWidth","justify-center"
              ]
            },
            {
              eldId:"02",
              name:"Discount",
              text:"50%",
            },
            {
              eldId:"03",
              name:"Product Name",
              text:"Men's Jacket",
              isLink:true,
              linkType:LinkType.TEXT,
              action:"goToProduct"
            },
            {
              eldId:"04",
              name:"Category",
              text:"Men's Clothing",
              isLink:true,
              linkType:LinkType.TEXT,
              action:"goToCategory"
            },
            {
              eldId:"05",
              name:"Add To Cart",
              isLink:true,
              text:"Add To Cart",
              action:"addToCart",
              linkType:LinkType.ICON,
              iconClass:"fa fa-shopping-bag"
            },
            {
              eldId:"06",
              name:"Add To Wish List",
              isLink:true,
              text:"Add To Wish List",
              action:"addToWishList",
              linkType:LinkType.ICON,
              iconClass:"far fa-heart"
            },
          ]
        }
      ]
    }
  }

  @ViewChild('expandable',{read:ElementRef}) expandable:ElementRef<HTMLElement>

  constructor(
    protected ref: NbDialogRef<HomeProductListComponent>,
    private el:ElementRef<HTMLElement>,
    private dialogService: NbDialogService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit():void{
    const overlayPane = this.el.nativeElement.parentElement.parentElement;
    const overlayWrapper = this.el.nativeElement.parentElement.parentElement.parentElement;
    setTimeout(() => {
      overlayWrapper.style.left ="0px";
      overlayWrapper.style.justifyContent = "flex-end";
      overlayWrapper.style.right = "16px";
      //overlayPane.style.width = "256px";
      overlayPane.style.marginRight = "16px";
      overlayPane.style.marginTop = "58px";
      overlayPane.style.display = "block";
    }, 1);


    //return el.parentElement.parentElement.parentElement.parentElement;
  }

  toggleContainer(){
    this.expandable.nativeElement.classList.toggle("collapsed");
    this.collapsed != this.collapsed;
  }

  close(e){
    this.ref.close();
  }

  createGrid(numberOfCells:number){
    let component:Type<any> = ProductListInputDialogComponent;
    let layoutClass = "grid-"+numberOfCells;

    console.log(layoutClass)

    this.dialogService.open(component, {
      context:{
        rendererType:RendererType.ROW,
        layoutClass:layoutClass,
        title:"Adding new section with grid layout"
      }
    }).onClose.subscribe(() => {
      console.log("closing")
      /* this.previewEditStoreService.selectedPage$.subscribe((page:Page) => {
        console.log(page);
        if(page != null && page != undefined){
          this.communicator.sendFromParent({id:"selectedPage",data:page});
        }
        
      }) */
    })
    this.ref.close();
  }

}
